import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) Gerenciamento de Contas In-app banking.",
    correct: false,
  },
  {
    option: "b) Assessoria Inteligente in-app banking.",
    correct: true,
  },
  {
    option: "c) Assistente Virtual de Onboarding WhatsApp Chatbots.",
    correct: false,
  },
  {
    option: "d) Gerenciamento de Contas Voice assistant.",
    correct: false,
  },
  {
    option:
      "e) Plataforma exclusiva para transações financeiras internacionais.",
    correct: false,
  },
];

export default function Question24(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question24: {
          title:
            "Qual ferramenta da Topaz oferece uma experiência ágil, eficiente e personalizada, simplificando o processo de abertura de conta digital por meio de interações via chatbot?",
          option: option.option,
          correct: option.correct,
          order: 24
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t(
          "Qual ferramenta da Topaz oferece uma experiência ágil, eficiente e personalizada, simplificando o processo de abertura de conta digital por meio de interações via chatbot?"
        )}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
